var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      false
        ? _c(
            "div",
            { staticClass: "top" },
            [
              _c(
                "p",
                {
                  staticStyle: { overflow: "hidden" },
                  on: {
                    mouseleave: function ($event) {
                      return _vm.leave(500)
                    },
                    mouseenter: _vm.enter,
                  },
                },
                [
                  _c("img", {
                    staticClass: "all",
                    attrs: { src: require("@/assets/home/all.png"), alt: "" },
                  }),
                  _c("span", [_vm._v("产品与服务")]),
                ]
              ),
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.show
                  ? _c(
                      "div",
                      {
                        staticClass: "top-menu",
                        on: {
                          mouseleave: function ($event) {
                            return _vm.leave(100)
                          },
                          mouseenter: _vm.enter,
                        },
                      },
                      [
                        _c(
                          "el-scrollbar",
                          {
                            staticStyle: { height: "100%" },
                            attrs: { "wrap-class": "list" },
                          },
                          [
                            false
                              ? _c("p", { staticClass: "search" }, [
                                  _c("i", { staticClass: "el-icon-search" }),
                                  _c("input", {
                                    attrs: {
                                      type: "text",
                                      placeholder: "请输入关键词",
                                    },
                                  }),
                                ])
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "lately" },
                              [
                                _c("h5", [_vm._v("最近访问")]),
                                _c(
                                  "el-row",
                                  _vm._l(
                                    _vm.commonMenu,
                                    function (item, index) {
                                      return _c(
                                        "el-col",
                                        { key: index, attrs: { span: 6 } },
                                        [
                                          _c(
                                            "a",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.clickTopNav(
                                                    item.path,
                                                    item.title,
                                                    item.parent,
                                                    item.icon,
                                                    item.id,
                                                    item.currentPage
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(item.title) + " "
                                              ),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    item.parent
                                                      ? "(" + item.parent + ")"
                                                      : ""
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              { staticClass: "service-list" },
                              _vm._l(_vm.allMenu, function (item, index) {
                                return _c(
                                  "el-col",
                                  { key: index, attrs: { span: 24 } },
                                  [
                                    _c(
                                      "h5",
                                      {
                                        style: {
                                          cursor: item.Url ? "pointer" : "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.clickParent(item)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(item.Title))]
                                    ),
                                    _vm._l(item.children, function (child, ii) {
                                      return _c(
                                        "el-col",
                                        { key: ii, attrs: { span: 6 } },
                                        [
                                          _c(
                                            "a",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.clickTopNav(
                                                    child.Url,
                                                    child.Title,
                                                    item.Title,
                                                    child.ICon,
                                                    child.ID,
                                                    child.IsCurrentPageOpen
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(child.Title))]
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-scrollbar",
        {
          staticStyle: { "overflow-x": "hidden" },
          attrs: { wrapClass: "scrollbar-wrapper" },
        },
        [
          _c(
            "el-menu",
            {
              attrs: {
                mode: "vertical",
                "show-timeout": 200,
                "default-active": _vm.$route.path,
                collapse: false,
                "background-color": "#001529",
                "text-color": "#fff",
                "active-text-color": "#fff",
              },
            },
            _vm._l(_vm.routes, function (route) {
              return _c("sidebar-item", {
                key: route.name,
                attrs: { item: route, "base-path": route.path },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }